import Client from 'config/axios';
import posthog from 'posthog-js';

export interface GroupData {
  name: string;
  companyId: number;
  records: any;
}

export const createGroup = async (token: string, groupData: GroupData) => {
  try {
    const { data } = await Client.post('group', groupData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('CreateGroup', {
      CreateGroup: data
    });

    return {
      data: data,
      errors: data.errors || null
    };
  } catch (response) {
    const result = response as any;
    return {
      data: null,
      errors: result.response?.data || result.data || result.message
    };
  }
};
